// extracted by mini-css-extract-plugin
export default {"no-margin":"ej1fi"};